import {useState} from "react";
import {Modal, Button, Spinner} from "react-bootstrap";

/**
 * @function AppUpdateModal
 * @params show, onRefresh
 * @description Notifies the user a new version of the app has been deployed
 * and lets them refresh to load it. Not dismissible via backdrop/escape so
 * it doesn't get lost - "Later" is the only intentional way to postpone it.
 */
const AppUpdateModal = ({show, onRefresh}) => {
    const [refreshing, setRefreshing] = useState(false);
    const [dismissed, setDismissed] = useState(false);

    const handleRefresh = () => {
        setRefreshing(true);
        onRefresh();
    };

    const handleLater = () => {
        setDismissed(true);
    };

    return (
        <Modal
            show={show && !dismissed}
            onHide={handleLater}
            centered
            backdrop="static"
            keyboard={false}
            contentClassName="border-0 shadow-lg"
            style={{borderRadius: "1rem"}}
        >
            <Modal.Body className="text-center px-4 pt-4 pb-3">
                <div
                    className="mx-auto mb-3 d-flex align-items-center justify-content-center"
                    style={{
                        width: 56,
                        height: 56,
                        borderRadius: "50%",
                        background: "rgba(13, 110, 253, 0.1)",
                        fontSize: 28,
                    }}
                >
                    🚀
                </div>

                <h5 className="fw-semibold mb-2">A new version is ready</h5>
                <p className="text-muted mb-0" style={{fontSize: "0.95rem"}}>
                    We've shipped some improvements and fixes. Refresh whenever you're ready to pick
                    them up — it only takes a second.
                </p>
            </Modal.Body>

            <Modal.Footer className="border-0 justify-content-center pb-4 pt-1">
                <Button
                    variant="outline-secondary"
                    className="rounded-[12px] "
                    onClick={handleLater}
                    disabled={refreshing}
                >
                    Remind me later
                </Button>
                <Button
                    variant="primary"
                    className="px-4 rounded-[12px] text-white"
                    onClick={handleRefresh}
                    disabled={refreshing}
                >
                    {refreshing ? (
                        <>
                            <Spinner as="span" animation="border" size="sm" className="me-2" />
                            Refreshing...
                        </>
                    ) : (
                        "Refresh now"
                    )}
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default AppUpdateModal;
